import React, { FC } from 'react';
import { IconInputWarningIcon } from 'src/components/Icons/InputWarning';

type Props = {
  error: string | false | undefined;
};

export const MaterialErrorMessage: FC<Props> = ({ error }) =>
  error ? (
    <span className="validation error custom">
      <IconInputWarningIcon />
      <div className="validation-result">{error}</div>
    </span>
  ) : null;
